
export const Footer = () => {

    return (
        <div className={'footer-container'}>
            <div className={'footer'}>
                &copy; Powered by HungryScan
            </div>
        </div>
    );
};
